<template>
  <WidgetCard title="Handledardispenser" :subtitle="subTitle">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'Avser', value: 'name', width: '280', sortable: true},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '129', sortable: false},
        {text: 'Yrke', value: 'profession', width: '180', sortable: true},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Status/Agerat', value: 'issuedBy', width: '180', sortable: false},
        {text: 'Datum', value: 'issuedOn', sortable: false, width: '100', sortable: false},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="items"
      item-key="id"
      class="clickable"
      :items-per-page="-1"
      @click:row="clickPerson"
    >
      <!-- Application name header -->
      <template slot="item.name" slot-scope="props"
        >{{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})</template
      >

      <template slot="item.issuedBy" slot-scope="props">
        {{ printStatus(get(props, 'item.issuedBy', null)) }}
      </template>

      <template slot="item.createdAt" slot-scope="props">
        <span class="widget-normal">{{ props.item.createdAt | date }}</span>
      </template>

      <template slot="item.issuedOn" slot-scope="props">
        <span class="widget-normal">{{ get(props, 'item.issuedOn', '') | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import { printStatus } from '@/helpers'
import get from 'lodash/get'
import { mapGetters } from 'vuex'
// @group Widgets
// InstructorExemption component
export default {

  name: 'InstructorExemption',

  components: {
    WidgetCard
  },

  props: {
    companyId: {
      type: Number,
      default: null
    },
    filter: {
      type: String,
      default: null
    },
    subTitleHidden: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: []
  }),

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.getIEs()
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['handledCasesAreVisible']),

    subTitle() {
      return this.subTitleHidden ? '' : 'Att granska och bekräfta'
    }
  },

  created() {
    this.getIEs()
  },

  methods: {
    printStatus,

    get,

    clickPerson(item) {
      this.$nextTick(() =>
        this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '2'}}).catch(() => {})
      )
    },
    /**
     * @vuese
     * Used to fetch the list of Instructor Exemptions
     * @arg called with no argument
     */
    getIEs() {
      let data = { toggleMyHandledCases: this.handledCasesAreVisible }

      if ( this.companyId ) {
        data = { companyId: this.companyId, ...(this.filter ? { filter: this.filter } : null) }
      }

      API.widgetInstructorExemptions({ data })
        .then(res => {

          this.items = []

          this.items = res.data.rows.map(ie => {
            let employmentType = []
            
            if( ie.person?.apprenticeships.length ) {
              employmentType = ie.person?.apprenticeships
            }

            if( ie.person?.employments.length ) {
              employmentType = ie.person?.employments
            }

            return {
              personalNumber: ie.person && ie.person.personalNumber ? ie.person.personalNumber : '',
              contractType: employmentType[0]?.company?.contracttype?.name ?? '',
              personId: ie.person && ie.person.id ? ie.person.id : '',
              name:
                ie.person && ie.person.firstName && ie.person.lastName
                  ? `${ie.person.firstName} ${ie.person.lastName}`
                  : '',
              issuedBy:
                ie.issuedBy && ie.issuedBy.firstName && ie.issuedBy.lastName
                  ? `${ie.issuedBy.firstName} ${ie.issuedBy.lastName}`
                  : '',
              state: ie.approveById ? ie.approveById : '',
              profession: ie.profession && ie.profession.name ? ie.profession.name : '',
              region: ie.region ? ie.region.name : '',
              issuedOn: ie.issuedOn ? ie.issuedOn : '',
              createdAt: ie.createdAt ? ie.createdAt : '',
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
</style>